export default "__VITE_ASSET__8177d058__"